export default "__VITE_ASSET__CUcTW1Xk__"